import { render, staticRenderFns } from "./CategoriaManter.vue?vue&type=template&id=35cfc3ae&"
import script from "./CategoriaManter.vue?vue&type=script&lang=js&"
export * from "./CategoriaManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports